import React, { useEffect, useCallback, useState } from 'react';

import BobLoadingMask from '../../../components/BobLoadingMask';

import { connect } from 'react-redux';

import { Grid, getSelectedState, GridColumn as Column } from '@progress/kendo-react-grid';
import { getter } from '@progress/kendo-react-common';
import { orderBy } from '@progress/kendo-data-query';

/*import EquipmentTypeTableContextMenu from './EquipmentTypeTableContextMenu';*/

import * as classes from './Table.module.css';

const idGetter = getter('id');

const EquipmentTypeTable = ({
    equipmentTypes,
    refreshTab,
    setRefreshTab,
    searchTerm,
    ...props
}) => {
    const [pageable] = useState({ buttonCount: 0, info: true, previousNext: false });
    const [sort, setSort] = useState([]);
    const [dataState, setDataState] = useState(
        equipmentTypes.map((dataItem) =>
            Object.assign(
                {
                    selected: false,
                },
                dataItem
            )
        )
    );
    const [selectedState, setSelectedState] = useState({});

    useEffect(() => {
        setDataState(equipmentTypes.filter(item => item.name.includes(searchTerm)).map((dataItem) =>
            Object.assign(
                {
                    selected: false,
                },
                dataItem
            )
        ));
    }, [searchTerm]);

    useEffect(() => {
        if (equipmentTypes) setDataState(equipmentTypes.map((dataItem) =>
            Object.assign(
                {
                    selected: false,
                },
                dataItem
            )
        ));
    }, [equipmentTypes]);

    useEffect(() => {
        const refresh = async () => {
            setDataState(equipmentTypes.filter(item => item.name.includes(searchTerm)).map((dataItem) =>
                Object.assign(
                    {
                        selected: false,
                    },
                    dataItem
                )
            ));
            setTimeout(() => {
                setRefreshTab();
            }, 750);
        };

        if (refreshTab) refresh();
    }, [refreshTab]);

    const onHeaderSelectionChange = useCallback((event) => {
        const checkboxElement = event.syntheticEvent.target;
        const checked = checkboxElement.checked;
        const newSelectedState = {};
        event.dataItems.forEach((item) => {
            newSelectedState[idGetter(item)] = checked;
        });
        setSelectedState(newSelectedState);
    }, []);

    const onSelectionChange = React.useCallback(
        (event) => {
            const newSelectedState = getSelectedState({
                event,
                selectedState: selectedState,
                dataItemKey:   'id',
            });
            setSelectedState(newSelectedState);
        },
        [selectedState]
    );

    //const actionsCell = props => {
    //    return (
    //        <td>
    //            <EquipmentTypeTableContextMenu />
    //        </td>
    //    );
    //};

    return (
        <div className={classes.Table}>
            <Grid
                sortable
                sort={sort}
                onSortChange={(e) => {
                    setSort(e.sort);
                }}
                className={classes.KendoGrid}
                data={orderBy(dataState, sort).map((item) => ({
                    ...item,
                    'selected': selectedState[idGetter(item)],
                }))}
                dataItemKey="id"
                selectedField="selected"
                selectable={{
                    enabled: true,
                    drag:    false,
                    cell:    false,
                    mode:    'multiple'
                }}
                onSelectionChange={onSelectionChange}
                onHeaderSelectionChange={onHeaderSelectionChange}
                total={equipmentTypes.length}
                reorderable
                pageable={pageable}
                pageSize={equipmentTypes.length}
            >
                <Column
                    field="selected"
                    width="70px"
                    headerSelectionValue={
                        dataState.length > 0 && dataState.findIndex((item) => !selectedState[idGetter(item)]) === -1
                    }
                />
                <Column
                    field="name"
                    title="Equipment Type"
                    width="auto"
                />
                {/*<Column*/}
                {/*    field=""*/}
                {/*    title=""*/}
                {/*    width="auto"*/}
                {/*    cell={actionsCell}*/}
                {/*/>*/}
            </Grid>
            {
                refreshTab === 'Equipment Types' ?
                    <BobLoadingMask />
                    :
                    null
            }
        </div>
    );
};

const mapStateToProps = state => ({
    equipmentTypes: state.lookup.equipmentTypes
});

export default connect(mapStateToProps, null)(EquipmentTypeTable);
